import React from 'react'
import {css} from '@emotion/core'
import StartpageLogo from '../../images/startpage-logo-gradient-dark.svg'
import twitterIcon from '../../images/social-icons/twitter.svg'
import redditIcon from '../../images/social-icons/reddit.svg'
import facebookIcon from '../../images/social-icons/facebook.svg'
import instagramIcon from '../../images/social-icons/instagram.svg'
import mastodonIcon from '../../images/social-icons/mastodon.svg'

const footerTranslations = require('../../translations/footer.json')

const BackgroundSquiggleFooter = ({className}) => (
    <svg
        className={className}
        width="1440"
        height="79"
        viewBox="0 0 1440 79"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_2464_114)">
            <path
                d="M1386 337.42C1415.96 344.284 1436.47 351.059 1445 357L1445 82.2069C1411 48.3782 1133 -45.7242 719 27.5605C305 100.845 18.9999 67.3739 -199 12.7275L-199 275.03C-156.882 289.733 -111.65 300.842 -64 309.037L-64 405L1386 405L1386 337.42Z"
                fill="#1B1D21"
            />
        </g>
        <defs>
            <clipPath id="clip0_2464_114">
                <rect width="1440" height="78.9999" fill="white" transform="translate(1440 79) rotate(-180)" />
            </clipPath>
        </defs>
    </svg>
)

const AboutFooter = ({themeStyles, lang, pageBackground}) => {
    const localizations = footerTranslations[lang]
    const {footerlinks} = localizations
    const socialIcons = [
        {
            url: `https://twitter.com/startpage`,
            icon: twitterIcon,
            label: `twitter`,
        },
        {
            url: `https://www.reddit.com/r/StartpageSearch/`,
            icon: redditIcon,
            label: `reddit`,
        },
        {
            url: `https://www.instagram.com/startpage/`,
            icon: instagramIcon,
            label: `instagram`,
        },
        {
            url: `https://www.facebook.com/startpagesearch/`,
            icon: facebookIcon,
            label: `facebook`,
        },
        {
            url: `https://mastodon.social/@StartpageSearch`,
            icon: mastodonIcon,
            label: `mastodon`,
        },
    ]
    return (
        <div
            css={css`
                overflow: hidden;
            `}
        >
            <div
                css={css`
                    width: 100%;
                    background: ${pageBackground ||
                        (themeStyles.about && themeStyles.about.subsection2BottomSquiggleFillColor) ||
                        '#F2F3FF'};
                `}
            >
                <BackgroundSquiggleFooter
                    css={css`
                        width: 100%;
                        height: auto;
                        display: block;
                        margin-bottom: -2px;
                    `}
                />
            </div>
            <div
                css={css`
                    padding: 71px 100px 80px;
                    background: #1b1d21;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    @media (${themeStyles.breakPoints.tabletLarge}) {
                        padding: 71px 50px 80px;
                    }
                    @media (${themeStyles.breakPoints.tabletMedium}) {
                        flex-direction: column;
                        padding: 80px 0;
                    }
                `}
            >
                <StartpageLogo
                    css={css`
                        width: 104px;
                        @media (${themeStyles.breakPoints.tabletMedium}) {
                            margin-bottom: 35px;
                        }
                        @media (${themeStyles.breakPoints.mobile}) {
                            margin-bottom: 65px;
                        }
                    `}
                />
                <div
                    css={css`
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 48px;
                        @media (${themeStyles.breakPoints.desktopSmall}) {
                            gap: 32px;
                        }
                        @media (${themeStyles.breakPoints.tabletMedium}) {
                            margin-bottom: 42px;
                        }
                        @media (${themeStyles.breakPoints.mobile}) {
                            flex-direction: column;
                            margin-bottom: 72px;
                        }
                    `}
                >
                    {footerlinks.map((link) => {
                        const localizedUrl = link.url.replace('{0}', lang)
                        return (
                            <a
                                href={localizedUrl}
                                key={link.text}
                                css={css`
                                    color: #fff;
                                    text-decoration: none;
                                    font-size: 14px;
                                    font-weight: 400;
                                    line-height: 20px;
                                    @media (${themeStyles.breakPoints.mobile}) {
                                        font-size: 18px;
                                        line-height: 28px;
                                    }
                                    &:nth-of-type(1) {
                                        @media (${themeStyles.breakPoints.mobile}) {
                                            order: 1;
                                        }
                                    }
                                `}
                            >
                                {link.text}
                            </a>
                        )
                    })}
                </div>
                <div
                    className="social"
                    css={css`
                        display: flex;
                        @media (${themeStyles.breakPoints.mobile}) {
                            gap: 24px;
                        }
                    `}
                >
                    {socialIcons.map(({url, icon, label}, i) => {
                        const Icon = icon
                        return (
                            <a
                                href={url}
                                rel="noopener nofollow"
                                aria-label={label}
                                key={i}
                                css={css`
                                    svg {
                                        height: 32px;
                                        width: 32px;
                                        display: block;
                                        circle {
                                            fill: #5668f1;
                                        }
                                        path {
                                            fill: #fff;
                                        }
                                    }
                                    margin: 0 0.5rem 0 0;
                                    @media (${themeStyles.breakPoints.mobile}) {
                                        margin: 0;
                                    }
                                `}
                            >
                                <Icon width={32} height={32} />
                            </a>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default AboutFooter
